module.exports = __webpack_public_path__ + "img/add-to-cart.54cd7a4e.png";